/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header, UsersItemListComp } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import { useSMUsersListPageGetContent, useSMNotifyUserUser } from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { WorkPermitListPageService } from '../services';
import { Modal } from 'react-bootstrap';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { AppNavigatorService } from '@/AppNavigator';
import { USER_LEVEL } from '@/config/userManagement.config';

const getSrv = () => {
  return vappContainer.get<WorkPermitListPageService>(
    WorkPermitListPageService.displayName
  );
};
const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const storageService = StorageModule.getInstance();
  const appSrv = getAppSrv();

  const setApplicationsForPayment = (data: any[]) => {
    storageService.set('payableApplications', data, 'session');
    props?.onPaymentClick && props?.onPaymentClick();
  };

  const srv = getSrv();

  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});
  const [whoAmI, setWhoAmI] = useState('');

  const { notifyUserUserSend, notifyUserUserState } = useSMNotifyUserUser({});

  const _onHeaderDDActionItemClick = (id: string) => {};

  const onError = () => {
    //window.location.reload(false);
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onRefresh = () => {
    usersListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any, status: any) => {
    let criteria: any = [];
    if (data?.credentialNo) {
      criteria = [
        {
          column: 'credentialNo',
          op: 'Equal',
          value: data?.credentialNo,
        },
      ];
    }
    if (status) {
      criteria = [
        ...criteria,
        {
          column: 'status',
          op: 'Equal',
          value: status,
        },
      ];
    }

    usersListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
  };

  useEffect(() => {
    getWhoamI();
  }, []);

  const onTogglePress = (key: string, id: string,type:string) => {
    console.log(`on toggle press ::`, key, id,type);
    if (key === 'notify') {
      notifyUserUserSend('START', {
        payload: {
          applicationID: id,
        },
      });
    }
    if (key === 'renew') {
      props?.onViewClick && props?.onViewClick(id,type);
    }
  };

  const _renderPage = () => {
    console.log(
      'usersListPageState?.event?.data?.value1',
      usersListPageState?.event?.data?.value
    );

    if (USER_LEVEL.owner.includes(whoAmI)) {
      if (usersListPageState?.matches('GET_PAGE_CONTENT')) {
        return (
          <Loader {...(staticPageContentConfig?.loading?.loadingUsers || {})} />
        );
      }

      if (usersListPageState?.matches('RENDER_PAGE')) {
        return (
          <>
            {usersListPageState?.event?.data?.value?.isEmpty ? (
              <StateOSD
                {...(staticPageContentConfig?.loading?.usersEmpty || {})}
              />
            ) : (
              <UsersListComp
                {...(usersListPageState?.event?.data?.value || {})}
                onTogglePress={onTogglePress}
                // onViewClick={props?.onViewClick}
                onRowClick={props?.onViewDetailClick}
              />
            )}
          </>
        );
      }
    } else {
      if (
        usersListPageState?.matches('GET_PAGE_CONTENT') ||
        !usersListPageState?.event?.data?.value?.isEmpty
      ) {
        return (
          <UsersItemListComp
            {...(usersListPageState?.event?.data?.value || {})}
            // onListClick={props?.onViewClick}
            isLoading={usersListPageState?.matches('GET_PAGE_CONTENT')}
            onRowClick={props?.onViewDetailClick}
          />
        );
      }
    }

    if (usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
      );
    }
    return <></>;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    usersListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(usersListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
    </div>
  );
};
